import {
	GetFormioFormsEndPoint,
	GetFormioFormByIdEndPoint,
	CreateFormioFormEndPoint,
	UpdateFormioFormEndPoint,
	DeleteFormioFormEndPoint,
	CreateFormioSubmissionEndPoint,
} from "common/constants";
import { makeAuthenticatedRequest } from "helpers/authenticatedRequest";

// Form calls go to the backend with the Keycloak token only; the backend talks to Form.io with its
// own service account (no Form.io token in the browser).
export const getForms = async (signal) => {
	return await makeAuthenticatedRequest(GetFormioFormsEndPoint, {
		method: "GET",
		signal,
	});
};

export const getForm = async ({ formId, formPath }, signal) => {
	return await makeAuthenticatedRequest(`${GetFormioFormByIdEndPoint}${formId || formPath}`, {
		method: "GET",
		signal,
	});
};

export const createForm = async (formData, signal) => {
	return await makeAuthenticatedRequest(CreateFormioFormEndPoint, {
		method: "POST",
		body: JSON.stringify(formData),
		signal,
	});
};

export const updateForm = async (formId, formData, signal) => {
	return await makeAuthenticatedRequest(`${UpdateFormioFormEndPoint}${formId}`, {
		method: "PUT",
		body: JSON.stringify(formData),
		signal,
	});
};

export const deleteForm = async (formId, signal) => {
	return await makeAuthenticatedRequest(`${DeleteFormioFormEndPoint}${formId}`, {
		method: "DELETE",
		signal,
	});
};

export const createSubmission = async (formId, submissionData, processInstanceId, taskId, signal) => {
	const params = new URLSearchParams();
	if (processInstanceId) params.append("processInstanceId", processInstanceId);
	if (taskId) params.append("task_id", taskId);
	const query = params.toString() ? `?${params.toString()}` : "";

	return await makeAuthenticatedRequest(`${CreateFormioSubmissionEndPoint}${formId}/submissions${query}`, {
		method: "POST",
		body: JSON.stringify(submissionData),
		signal,
	});
};

// Continues an existing submission - the backend merges these fields into
// the submission's current payload, so only the changed fields need to be
// sent here (unlike createSubmission, which is the full initial payload).
export const updateSubmission = async (formId, submissionId, submissionData, processInstanceId, taskId, signal) => {
	const params = new URLSearchParams();
	if (processInstanceId) params.append("processInstanceId", processInstanceId);
	if (taskId) params.append("task_id", taskId);
	const query = params.toString() ? `?${params.toString()}` : "";

	return await makeAuthenticatedRequest(`${CreateFormioSubmissionEndPoint}${formId}/submissions/${submissionId}${query}`, {
		method: "PATCH",
		body: JSON.stringify(submissionData),
		signal,
	});
};
